import React from 'react';
import { useIntl } from 'react-intl';
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports
import { Subscribe } from 'unstated';

import type { EditorActions } from '@atlaskit/editor-core';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary.ts';
import { EmojiTitleStateContainer } from '@confluence/emoji-title/entry-points/emojiTitleStateContainer.ts';
import { CoverPictureStateContainer } from '@confluence/page-cover-picture/entry-points/CoverPictureStateContainer.ts';

import { SaveIndicatorComponent } from './SaveIndicatorComponent.tsx';
export type SaveIndicatorProps = {
	editorActions: EditorActions | undefined;
	saveError: boolean;
	title: string | null;
};

const SaveIndicatorWrapper = ({ editorActions, saveError, title }: SaveIndicatorProps) => {
	const { formatMessage } = useIntl();

	return (
		<Subscribe to={[EmojiTitleStateContainer, CoverPictureStateContainer]}>
			{(
				emojiTitleState: EmojiTitleStateContainer,
				coverPictureState: CoverPictureStateContainer,
			) => {
				const selectingEmojiTitle = emojiTitleState.state.isUpdatingEmoji;
				const selectingCoverPicture =
					coverPictureState.state.isUploadingPicture ||
					coverPictureState.state.isRemovingPicture ||
					coverPictureState.state.isRepositioningPicture;
				const hasEmoji = !!emojiTitleState.state.selectedEmoji;
				const hasCoverPicture = coverPictureState.state.hasCoverPicture;
				return (
					<SaveIndicatorComponent
						editorActions={editorActions}
						saveError={saveError}
						title={title}
						hasEmoji={hasEmoji}
						hasCoverPicture={hasCoverPicture}
						selectingEmojiTitle={selectingEmojiTitle}
						selectingCoverPicture={selectingCoverPicture}
						formatMessage={formatMessage}
					/>
				);
			}}
		</Subscribe>
	);
};

export const SaveIndicator = withTransparentErrorBoundary({
	attribution: Attribution.PAGE_MODES,
})(SaveIndicatorWrapper);
